import { createContext } from "react";
import { Picker } from "../types";

const pickerContext = createContext<Picker.ContextType>({
  firstDayOfWeek: "sunday",
  reset: () => {},
  onNextMonth: async () => {},
  onPrevMonth: async () => {},
  rtl: false
});

export default pickerContext;
